"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const ProfilePictureHolder = _styledComponents.default.div.withConfig({
  displayName: "ProfilePicture__ProfilePictureHolder",
  componentId: "design-system__sc-103pb73-0"
})(["width:40px;height:40px;overflow:hidden;border:1px solid ", ";border-radius:50%;position:relative;"], _BaseTheme.default.colors.gray);

const Picture = _styledComponents.default.div.withConfig({
  displayName: "ProfilePicture__Picture",
  componentId: "design-system__sc-103pb73-1"
})(["width:40px;height:40px;background-clip:padding-box;float:left;background-size:cover;background-position:center center;background-image:url(", ")"], props => props.url);

const ProfilePicture = _ref => {
  let {
    imageUrl
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(ProfilePictureHolder, null, /*#__PURE__*/_react.default.createElement(Picture, {
    url: imageUrl
  }));
};

ProfilePicture.propTypes = {
  imageUrl: _propTypes.default.string.isRequired
};
var _default = ProfilePicture;
exports.default = _default;